import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import { useDispatch, useSelector } from "react-redux";
import KmlFileUploader from "../../../../TCPForms/reusableComponents/KmlFileUploader";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import TravelExploreOutlinedIcon from "@mui/icons-material/TravelExploreOutlined";
import { IconButton } from "@mui/material";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { Loader } from "@egovernments/digit-ui-react-components";

const SubStep4 = ({ formData, handleTabChange, isEmployee }) => {
  console.log(formData, "formDagta");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { initFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { documents } = useSelector((state) => state.formMT);
  const [showError, setShowError] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...formData?.descriptionOfLand,
    },
    documents: documents,
  };
  const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({ defaultValues });

  useEffect(() => {
    if (formData?.documents?.length > 0) {
      initFormMTDocs(formData.documents);
    }
  }, [documents, formData?.documents]);

  console.log("Documents787878", documents);

  const kmlFile = documents?.find((doc) => doc?.documentType === "kmlFile") || null;

  console.log("kmlFile", kmlFile);

  const onSubmit = (data) => {
    handleTabChange(1, data);
  };
  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">GEO Location</h2>
          </div>

          <div className="formInputContainer common-app-form self-certified custom-upload new-custom-uploader">
            <div className="columnWrapper">
              <InputWrapper
                label="Latitude"
                control={control}
                placeholder="Enter Latitude"
                name="descriptionOfLand.latitude"
                type="textInput"
                mandatory
                defaultValue={formData?.descriptionOfLand?.latitude}
                validation={{
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                }}
                maxLength={10}
                disabled={formData?.descriptionOfLand?.latitude}
              />
              {!isEmployee && (
                // <KmlFileUploader
                //   name={"kmlFile"}
                //   label={"KML File"}
                //   isMandatory
                //   validationMsg={"(.kml file only and Max file Size 10 MB)"}
                //   required
                //   tab={1}
                //   showError={showError}
                //   // control={control}
                //   maxFiles={1}
                // />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    marginBottom: "8px",
                  }}
                >
                  <div style={{ fontSize: "14px", textAlign: "left", display: "inline-block", width: "50%" }}>KML File</div>

                  <IconButton size="large" color="info" onClick={() => getDocumentByFileStoreId(kmlFile?.fileStoreId, setIsPreviewLoading)}>
                    {isPreviewLoading ? (
                      <div style={{ width: "14px", height: "14px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Loader />
                      </div>
                    ) : (
                      <TravelExploreOutlinedIcon color="primary" sx={{ fontSize: "18px" }} />
                    )}
                  </IconButton>
                </div>
              )}
            </div>
            <div className="columnWrapper">
              <InputWrapper
                label="Longitude"
                control={control}
                placeholder="Enter Longitude"
                name="descriptionOfLand.longitude"
                type="textInput"
                mandatory
                defaultValue={formData?.descriptionOfLand?.longitude}
                validation={{
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                }}
                maxLength={10}
                disabled={formData?.descriptionOfLand?.longitude}
              />
            </div>
            <br />
          </div>
        </div>
        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleSubTabChange(2)}
              />
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};

export default SubStep4;
